import { render, staticRenderFns } from "./EDLocationSearch.vue?vue&type=template&id=45194b03&"
import script from "./EDLocationSearch.vue?vue&type=script&lang=js&"
export * from "./EDLocationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports